module.exports = __webpack_public_path__ + "img/1_005.9238e540.jpg";